import { type ChipProps } from './Chip'

export const isNotDefault = (color: ChipProps['color']): color is Exclude<ChipProps['color'], 'default' | undefined> =>
  color !== 'default'
